import {  Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'customer-select',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.less']
})
export class CustomerComponent implements OnInit {
  isShow: boolean = false;
  // TODO: Update interface when API provides status fields
  // blockStatusFI: string (财务冻结 - Financial Freeze)
  // blockStatusSales: string (销售冻结 - Sales Freeze)
  // deleted: boolean (删除 - Deleted)
  items: { 
    customerCode: string, 
    customerName: string,
    blockStatusSales?: string,  // TODO: Remove when API provides this field
    deleted?: boolean  // TODO: Remove when API provides this field
  }[] = [];
  page: number = 1;
  pageSize: number = 20;
  loading: boolean = false;
  customerKeyword: string = "";
  selectedCustomerName: string ="";
  selectedCustomerCode: string="";
  selectedCustomerBlockStatusSales?: string;  // TODO: Remove when API provides this field
  selectedCustomerDeleted?: boolean;  // TODO: Remove when API provides this field
  total:number=0;

  @ViewChild('scrollableUl') scrollableUl!: ElementRef;

  constructor(private customerService: CustomerService) { }

  ngOnInit() {
      this.customerService.ensureValidCustomer().subscribe(() => {
        this.loadMoreCustomers().then(() => {
          this.customerService.selectFirstCustomerIfNone(this.items);
          const selectedCustomer = this.customerService.getSelectedCustomer();
          if (selectedCustomer) {
            this.selectedCustomerName = selectedCustomer.customerName;
            this.selectedCustomerCode = selectedCustomer.customerCode;
            this.selectedCustomerBlockStatusSales = (selectedCustomer as any).blockStatusSales;
            this.selectedCustomerDeleted = (selectedCustomer as any).deleted;
          }
        });
      });
  }

  chooseCustomer(customer: any) {
    this.customerService.setSelectedCustomer({ ...customer });
    this.selectedCustomerName = customer.customerName;
    this.selectedCustomerCode = customer.customerCode;
    this.selectedCustomerBlockStatusSales = customer.blockStatusSales;
    this.selectedCustomerDeleted = customer.deleted;
    this.isShow =false;
  }

  onEnter(): void {
    this.items = [];
    this.page =1;
    this.loadMoreCustomers();
  }

  onClear(): void {
    this.items = [];
    this.page =1;
    this.customerKeyword="";
    this.loadMoreCustomers();
  }

  onScroll(event: Event) {
    const target = event.target as HTMLElement;
    const scrollTop = target.scrollTop;
    const scrollHeight = target.scrollHeight;
    const clientHeight = target.clientHeight;
    if (scrollHeight - scrollTop <= clientHeight && !this.loading) {
      this.loadMoreCustomers();
    }
  }

  loadMoreCustomers(): Promise<any[]> {
    this.loading = true;
    return new Promise((resolve) => {
      this.customerService.loadMoreCustomers(this.page, this.pageSize, this.customerKeyword).subscribe(result => {
        this.total = result.data.customerRelationVOList.total;
        // TODO: Update when API provides status fields (blockStatusFI, blockStatusSales, deleted)
        this.items = result.data.customerRelationVOList.records?.map((item: any) => ({
          ...item,
          blockStatusSales: item.blockStatusSales || undefined,
          deleted: item.deleted || undefined
        }));
        // Sort: put blocked/deleted customers at the end
        this.items = this.sortCustomers(this.items);
        this.loading = false;
        resolve(this.items);
      });
    });
  }

  /**
   * Sort customers: normal customers first, blocked/deleted customers at the end
   */
  sortCustomers(customers: any[]): any[] {
    return [...customers].sort((a, b) => {
      const aHasIssue = this.hasCustomerIssue(a);
      const bHasIssue = this.hasCustomerIssue(b);
      if (aHasIssue === bHasIssue) return 0;
      return aHasIssue ? 1 : -1;
    });
  }

  /**
   * Check if customer has any status issues (blocked or deleted)
   */
  hasCustomerIssue(customer: any): boolean {
    return !!(customer.blockStatusSales || customer.deleted);
  }

  /**
   * Check if selected customer has any status issues
   */
  hasSelectedCustomerIssue(): boolean {
    return !!(this.selectedCustomerBlockStatusSales || this.selectedCustomerDeleted);
  }


  togglePopover(): void {
    this.isShow = !this.isShow;
  }

}
